module.exports = __webpack_public_path__ + "static/media/fruits_10.0976c118.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_10.csv
// module id = 674
// module chunks = 0